module.exports = __webpack_public_path__ + "static/media/Melanie-mini.7687376b.jpg";